import { render, staticRenderFns } from "./ProlificEntry.vue?vue&type=template&id=70cda8bc"
import script from "./ProlificEntry.vue?vue&type=script&lang=js"
export * from "./ProlificEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports